@if(!loading) {
<div class="h-100 v-center executor-wrapper">
  <span class="mx-auto header-5"> {{ message }} </span>
  <img [src]="'images/vs-code.svg' | assetUrl" alt="Icon" class="vs-img" />
</div>
@if(!isLaunchIDE) {
<div class="copy-container">
  <input
    type="text"
    class="copy-input general-text"
    [value]="copyText"
    readonly
    id="copyInput"
  />
  <button class="btn btn-secondary" (click)="copyToClipboard()">Copy</button>
</div>
<div class="d-flex justify-content-center custom-gap mt-4">
  <button
    class="btn btn-primary launch-btn mt-2 create-project-btn"
    (click)="openVsCode()"
  >
    Open IDE
  </button>
  <button
    class="btn btn-secondary mt-2 create-project-btn"
    (click)="closeVsCode()"
  >
    Destroy IDE @if(isDestroyed) {
    <span
      class="spinner-border spinner-border-sm mx-2"
      role="status"
      aria-hidden="true"
    ></span>
    }
  </button>
</div>
} @else {
<div class="d-flex justify-content-center custom-gap mt-4">
  <button class="btn btn-primary launch-btn mt-2 create-project-btn" (click)="launchIDE()">
    Launch IDE @if(isLoadingIDE) {
        <span
          class="spinner-border spinner-border-sm mx-2"
          role="status"
          aria-hidden="true"
        ></span>
        }
  </button>
</div>

} } @else {
<app-loading [text]="'Loading data'"></app-loading>
}
